import { gsap, Power1 } from 'gsap'


const staggerAnimation = (start, array, timeline, firstAppear, iterator, duration) => {
  for (let i = start; i < array.length; i++) {
    timeline.add(
      gsap.fromTo(
        array[i],
        { opacity: 0 },
        { opacity: 1, duration, ease: Power1.easeIn }
      ),
      i === 0 ? firstAppear : iterator
    )
  }
}

export default staggerAnimation
